import LiveCannelEdit from "./LiveCannelEdit";
import LiveCannelCreate from "./LiveChannelCreate";
import LiveVideosList from "./LiveChannelList";

export default {
    list: LiveVideosList,
    edit: LiveCannelEdit,
    create: LiveCannelCreate,
};
